module.exports = {"pageTitleText":"节点配置","createText":"添加节点","hostname":"主机名称","groupName":"群组","internalIP":"内网地址","externalIP":"外网地址","isEnableProxyProtocol":"代理协议","serviceIP":"服务地址","serviceProvideType":"服务型态","health":"健康度","isenabled":"启用状态","connectState":"连接状态","gitSitesSuccess":"更新状态","ninjaIsRunning":"Ninja","errMsg":"Error Message","status":"状态","removeFromGroup":"移除","removeFromGroupText":"您确定要移除此 Ninja Handler吗？"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/ninjasetting.json
// module id = wo5K
// module chunks = 3